const Gap = (props: { size: any; }) => {
  return <div style={{ marginTop: props.size }} />;
};
export default Gap;
